import { Model } from '@vuex-orm/core';
import { AddressSource, Salutations } from '@/utils/constants'

export default class Address extends Model {
    static entity = 'addresses';

    static fields() {
        return {
            id: this.increment(),
            customerId: this.string(''),
            addressSource: this.number(AddressSource.ManualAddress),
            //this field should be true for max 1 record at once. it means, that this is the auftraggeber identified by SAP with the migros-login-id
            isAuftraggeber: this.boolean(false),
            isWarenempfaenger: this.boolean(false),
            isRegulierer: this.boolean(false),
            salutation: this.number().nullable(),
            firstName: this.string(null).nullable(),
            lastName: this.string(null).nullable(),
            companyName: this.string(null).nullable(),
            street: this.string(null).nullable(),
            streetNumber: this.string(null).nullable(),
            addressLine2: this.string(null).nullable(),
            zipcode: this.number(null).nullable(),
            city: this.string(null).nullable(),
            countryCode: this.string(null).nullable(),
            phone: this.string(null).nullable(),
            emailAddress: this.string(null).nullable(),
            cumulusNumber: this.string(null).nullable(),
            mlGuid: this.string(null).nullable()
        }
    }

    get dropdown_name() {
        switch (this.salutation) {
            case Salutations.Company:
                return `${this.companyName}, ${this.street} ${this.streetNumber}, ${this.zipcode} ${this.city}`;
            default:
                return `${this.firstName} ${this.lastName}, ${this.street} ${this.streetNumber}, ${this.zipcode} ${this.city}`;
        }
    }

    get cumulusNumberWithoutPrefix() {
        if (this.cumulusNumber && this.cumulusNumber.indexOf('2099') === 0)
            return this.cumulusNumber.substring(4);
        else
            return '';
    }

    get isServerAddress() {
        return this.addressSource === AddressSource.ServerAddress;
    }

    get isMigrosLoginAddress() {
        return this.addressSource === AddressSource.MigrosLoginAddress;
    }
}